import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";

const WhatsAppButton = ({ phone = "233200000000", message = "Hello ObraSafe! I would like to make an enquiry." }) => {
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-button"
      className="fixed bottom-6 right-6 z-40 bg-[#25D366] hover:bg-[#1DA851] text-white flex items-center gap-2 px-5 h-14 font-bold uppercase tracking-wider text-sm shadow-[0_0_25px_rgba(37,211,102,0.45)] transition-transform hover:-translate-y-0.5"
      aria-label="Chat on WhatsApp"
    >
      <WhatsappLogo size={26} weight="fill" />
      <span className="hidden sm:inline">Chat with us</span>
    </a>
  );
};

export default WhatsAppButton;
